module.exports = __webpack_public_path__ + "media/search/go-arrow-e035e19c.svg";